// extracted by mini-css-extract-plugin
module.exports = {"itemList":"ManageAccountTable__itemList","emptyText":"ManageAccountTable__emptyText"};